import * as React from "react"
import { Layout } from "@bw/layouts"
import { PageHeader } from "@bw/modules"
import { Button, Section, Seo } from "@bw/bits"
import { useTranslation } from "react-i18next"

const NotFoundPage = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Seo title={t("404.title")} />
      <PageHeader
        title={t("404.title")}
        pictogram={
          <svg className="icon">
            <use xlinkHref={`/sprite-v2.svg#cross`} />
          </svg>
        }
      />
      <Section>
        <Button to="/" label={t("404.button")} />
      </Section>
    </Layout>
  )
}

export default NotFoundPage
